import { getIcon } from '@/HostApp/store/ApsModules/NavigationModule';

const normalizeAndMapIcon = function (apsPackage: APS.INavigationTreeItemPackage): string {
	if (apsPackage && apsPackage.icon && apsPackage.id && apsPackage.url) {
		return getIcon(apsPackage);
	} else {
		return '';
	}
};

const SpecialHelpers: SPH.SpecialHelpers = {
	normalizeAndMapIcon
};

export { SpecialHelpers };
